export interface CmsProtectionDetailsUpsellModal {
  protectionDetailsModalBenefitsListItems: ProtectionDetailsModalBenefitsListItem[];
  protectionDetailsModalBenefitsListTitle: string;
  protectionDetailsModalSubtitle: string;
  protectionDetailsModalTitle: string;
}

export interface ProtectionDetailsModalBenefitsListItem {
  item: string;
}
